module.exports = __webpack_public_path__ + "img/TAJBank+strapline_RGB_large.9aae0a31.png";